import HelpRequestTable from '../components/help-request-table/HelpRequestTable';
import { useEffect } from 'react';

import { useDashboardStore, useHelpRequestStore } from '@stores';

import Tabs from '@components/tabs/Tabs';

import '../dashboard.scss';
import { useNavigate } from '@tanstack/react-router';
import { Route } from '@src/routes/dashboard';

const TAB_MAPPING = {
  unclaimed: 0,
  claimed: 1,
  all: 2,
};

const tabData = [
  {
    title: 'Unclaimed Inquiries',
    content: <HelpRequestTable view='unclaimed' />,
  },
  {
    title: 'My Claimed Inquiries',
    content: <HelpRequestTable view='claimed' />,
  },
  {
    title: 'All Inquiries',
    content: <HelpRequestTable view='all' />,
  },
];

const RegulatorDashboard = (): JSX.Element => {
  const { tab: routeTab } = Route.useSearch();
  const { activeTab, setActiveTab } = useDashboardStore();
  const { setDistricts, setHelpCategories, setStatuses, setCounties, setStates } = useHelpRequestStore();
  const navigate = useNavigate();

  const handleTabChange = (tab: number) => {
    setActiveTab(tab);
    navigate({
      to: '/dashboard',
      search: () => ({ tab: tab === 0 ? undefined : tab === 1 ? 'claimed' : 'all' }),
    });

    // Reset filters on tab change
    setDistricts([]);
    setHelpCategories([]);
    setStatuses([]);
    setCounties([]);
    setStates([]);
  };

  useEffect(() => {
    if (routeTab === 'all') {
      setActiveTab(TAB_MAPPING.all);
    } else if (routeTab === 'claimed') {
      setActiveTab(TAB_MAPPING.claimed);
    } else {
      setActiveTab(TAB_MAPPING.unclaimed);
    }
  }, [routeTab, setActiveTab]);

  return (
    <div>
      <Tabs tabData={tabData} activeIndex={activeTab} onTabChange={handleTabChange} />
    </div>
  );
};

export default RegulatorDashboard;
